import React from "react";
import { Row, Col } from "antd";
import { Modal } from "../../../core";
import { Input, Typography, Button, Loading } from "../../../core";
import styled from "styled-components";
import { Form } from "antd";
import { MixStyle } from "../../../styles";
import { updateSelvedge } from "../../../helper/utils/api/settings";
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const EditSelvedgeModal = ({
  editSelvedgeModal,
  closeModal,
  getSelvedges,
  dataToEdit,
}) => {
  const [form] = Form.useForm();

  const [updatedValue, setUpdatedValue] = React.useState({});
  const [formInitialValue, setFormInitialValue] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setFormInitialValue(dataToEdit);
  }, [dataToEdit]);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    await updateSelvedgeRecordHandler();
    setIsLoading(false);
  };

  const updateSelvedgeRecordHandler = async () => {
    try {
      let selvedgeIdToEdit = formInitialValue._id;
      let response = await updateSelvedge(selvedgeIdToEdit, updatedValue);
      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler();
      getSelvedges();
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update selvedge"
      );
      console.log("error while update", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = (changedValues, valuse) => {
    console.log(changedValues);
    let companyId = localStorage.getItem("companyId");
    setUpdatedValue((prev) => ({
      ...prev,
      companyId,
      ...changedValues,
    }));
  };

  const closeModalHandler = () => {
    closeModal("editSelvedgeModal");
  };

  return (
    <Modal
      closable={true}
      visible={editSelvedgeModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Selvedge"
    >
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={formInitialValue}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="selvedge"
              rules={[
                {
                  required: true,
                  message: "Please Input Selvedge Value",
                },
              ]}
            >
              <Input
                type="text"
                className="text-center"
                placeholder="Selvedge"
              />
            </Form.Item>
          </Col>

          <Col md={22}>
            <Form.Item>
              <Row type="flex" justify="space-between">
                <Col md={12}>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    htmlType="submit"
                  >
                    <Typography
                      text="Update"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
                <Col md={12}>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    onClick={closeModalHandler}
                  >
                    <Typography
                      text="Cancel"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default EditSelvedgeModal;
